export const OK = 200;
export const CREATED = 201;
export const ACCEPTED = 202;

export const NOT_MODIFIED = 304;

export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 401;
export const PAYMENT_REQUIRED = 402;
export const FORBIDDEN = 403;
export const CONFLICT = 409;

export const SERVER_ERROR = 500;

export const SUCCESS = "success";
export const ERROR = "error";
export const IS_STRIPE_ENABLED = "isStripeEnabled";
export const IS_RECAPTCHA_PASSED = "isPassed";
export const RECORD_PER_PAGE = 10;

export const DEFAULT_CHARACTER_LENGTH = 160;
export const IS_BILLING_ENABLED = "isBillingEnabled";
export const APPICATION_NAME = "dotwork";

export const REACT_APP_CRYPTO_SECRET_KEY = "tellagent_key";

// static access token for api
export const REACT_APP_ACCESS_TOKEN = "dd5q6uzux2XMqTTF";

export const REACT_APP_RECAPTCHA = "6LeAhFAiAAAAAFbSyGY4Q7JF2VZ83pEoyFrr0I5A";

export const REACT_APP_GOOGLE_MAP_KEY =
  "AIzaSyB0s4ZScT4nqGTWTFJ1IRoNUM1Fqha-4nM";
